import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import getVenuesList from '../../../api/graphql/queries/getVenuesList';
import postAddVenue from '../../../api/graphql/mutations/postAddVenue';
// import postAddArtistSet from '../../../api/graphql/mutations/postAddArtistSet';
// import postAddTicket from '../../../api/graphql/mutations/postAddTicket';
// import postAddEvent from '../../../api/graphql/mutations/postAddEvent';
// import postDeleteTicket from '../../../api/graphql/mutations/postDeleteTicket';
import postDeleteVenue from '../../../api/graphql/mutations/postDeleteVenue';
// import postDeleteArtistSet from '../../../api/graphql/mutations/postDeleteArtistSet';
// import postDeleteEvent from '../../../api/graphql/mutations/postDeleteEvent';
import postEditVenue from '../../../api/graphql/mutations/postEditVenue';
// import postEditTicket from '../../../api/graphql/mutations/postEditTicket';
// import postEditArtistSet from '../../../api/graphql/mutations/postEditArtistSet';
// import postEditEvent from '../../../api/graphql/mutations/postEditEvent';
// import getPostsByCategory from '../../../api/graphql/queries/getPostsByCategory';
// import getPostsByType from '../../../api/graphql/queries/getPostsByType';
// import getPostBySlug from '../../../api/graphql/queries/getPostBySlug';
// import postAddPost from '../../../api/graphql/mutations/postAddPost';
// import postEditPost from '../../../api/graphql/mutations/postEditPost';
// import postDeletePost from '../../../api/graphql/mutations/postDeletePost';

import getPostsByType from '../../../api/graphql/queries/getPostsByType';

import Filter from '../../Tabs/Filter';
import DataTable from '../../Table/DataTable';
import venueColumns from './venueColumns';

import LoadIcon from '../../LoadIcon';

// import TabItem from '../../Tabs/TabItem';
import VenueForm from './VenueForm';
import Modal from '../../Modal/Modal';
import slugify from '../../../utils/slugify';

const DEFAULT_ROWS_PER_PAGE = 50;
// import DraggableList from '../../DraggableList';

const debounce = (func, delay) => {
  let inDebounce;
  return (...args) => {
    const context = this;
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => func.apply(context, args), delay);
  };
};

class VenuesContainer extends Component {
  state = {
    filterText: '',
    isCreateModalOn: false,
    isDisplayModalOn: false,
    isModifyModalOn: false,
    isDeleteModalOn: false,
    formOutput: {},
    currItemData: [],
    toggleDeleteInfoScreen: false,
    // initialItems: [],
    filteredItems: [],
    isLoading: true,
    canItemBeDeleted: false,
    routePosts: [],
    page: 0,
    total: 0,
    rowsPerPage: DEFAULT_ROWS_PER_PAGE,
    sorting: ['createdAt', -1],
  };

  // A new search starts again at the first page: staying on page 7 of the
  // previous result set would land the editor on an empty screen.
  updateSearch = debounce(async (val) => {
    this.setState({ filterText: val }, () => this.loadPage(0));
  }, 500);

  /*
  One page of venues. The list used to render nothing until four characters
  were typed, because the query returned the whole collection and there was
  nothing else holding it back; it pages now, so the first render can show real
  content and a search is a filter rather than a precondition.
  */
  loadPage = async (page = 0) => {
    const { filterText, rowsPerPage, sorting } = this.state;
    this.setState({ isLoading: true });
    const result = await getVenuesList((filterText || '').toLowerCase(), {
      limit: rowsPerPage,
      offset: page * rowsPerPage,
      sortField: sorting[0],
      sortOrder: sorting[1],
    });
    this.setState({
      filteredItems: (result && result.venues) || [],
      total: (result && result.total) || 0,
      page,
      isLoading: false,
    });
  };

  componentDidMount = () => {
    this.getPosts();
    this.loadPage(0);
  };

  // The table owns page size and sort order; both reset to the first page,
  // because a different page size or order makes the old offset meaningless.
  setRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage }, () => this.loadPage(0));
  };

  setSorting = (sorting) => {
    this.setState({ sorting }, () => this.loadPage(0));
  };

  getPosts = () => {
    getPostsByType('route')
      .then((res) => {
        if (res) {
          const { posts } = res;
          const routePosts = posts.map(post => post.slugName);
          this.setState({
            routePosts,
          });
        }
      })
      .catch(err => console.log(err, ' => getPostsByCategory'));
  };

  // getVenues = () => {
  //   const { history } = this.props;
  //   const { filterText } = this.state;
  //   this.setState({ isLoading: true });

  //   getVenuesList().then((venuesData) => {
  //     if (venuesData) {
  //       if (venuesData.isAuth) {
  //         let filteredItems = [];
  //         if (filterText) {
  //           filteredItems = venuesData.venues.filter(item => item.venueName && item.venueName.toLowerCase().includes(filterText.toLowerCase())).sort((a, b) => (a.venueName > b.venueName ? 1 : b.venueName > a.venueName ? -1 : 0));
  //           this.setState({ initialItems: venuesData.venues, filteredItems, isLoading: false });
  //         } else {
  //           filteredItems = venuesData.venues.sort((a, b) => (a.venueName > b.venueName ? 1 : b.venueName > a.venueName ? -1 : 0));
  //           this.setState({ initialItems: venuesData.venues, filteredItems, isLoading: false });
  //         }
  //       } else {
  //         console.log('getVenuesList - User authentication failed!');
  //         history.push('/login');
  //       }
  //     } else {
  //       console.log('venuesData = null');
  //     }
  //   });
  // };


  handleClick = (action, item) => {
    switch (action) {
      case 'create':
        this.toggleCreateModal();
        break;
      case 'display':
        this.toggleDisplayModal(item);
        break;
      case 'modify':
        this.toggleModifyModal(item);
        break;
      case 'delete':
        this.toggleDeleteModal(item);
        break;
      case 'closeDeleteItem':
        this.toggleDeleteInfoScreen();
        break;
      default:
        console.log('wrong action!');
        break;
    }
  };

  toggleCreateModal = () => {
    /* // Logic for getPostsByCategory ---------------------------------------------------------------------------------------

    const { history } = this.props;

    getPostsByCategory('barcelona').then((postsData) => {
      if (postsData) {
        if (postsData.isAuth) {
          console.log(postsData.posts);
        } else {
          console.log('getPostsByCategory - User authentication failed!');
          history.push('/login');
        }
      } else {
        console.log('postsData = null');
      }
    }); */

    /* // Logic for getPostsByType ---------------------------------------------------------------------------------------

    const { history } = this.props;

    getPostsByType('component').then((postsData) => {
      if (postsData) {
        if (postsData.isAuth) {
          console.log(postsData.posts);
        } else {
          console.log('getPostsByType - User authentication failed!');
          history.push('/login');
        }
      } else {
        console.log('postsData = null');
      }
    }); */

    /* // Logic for getPostBySlug ---------------------------------------------------------------------------------------

    const { history } = this.props;

    getPostBySlug('home').then((postData) => {
      if (postData) {
        if (postData.isAuth) {
          console.log(postData.post);
          console.log('The post\'s [ components ] JSON string converted back to a JSON object');
          console.log(JSON.parse(postData.post.components));
        } else {
          console.log('getPostBySlug - User authentication failed!');
          history.push('/login');
        }
      } else {
        console.log('postData = null');
      }
    }); */

    /* // Logic for postAddPost ---------------------------------------------------------------------------------------

    const { history } = this.props;

    const formData = {
      name: 'Test Page 3',
      postCategory: [
        'barcelona',
      ],
      postDescription: {
        title: {
          en: 'Primavera Sound',
          es: 'Primavera Sound',
          ca: 'Primavera Sound',
        },
        description: {
          en: 'Primavera Sound',
          es: 'Primavera Sound',
          ca: 'Primavera Sound',
        },
        image: {
          en: 'https://assets-img.primaverasound.com/fit-in/1440x768/image.jpg',
          es: null,
          ca: null,
        },
        position: 1,
        itemLayout: '0',
        tags: [
          'barcelona',
        ],
        active: true,
      },
      slugName: 'test-page-3',
      title: 'Test Page 3',
      type: 'route',
      components: '[{"key":"header-main"},{"type":"Body","slugName":"homeBody","components":[{"type":"Carousel","slugName":"homeCarousel","section":"home","components":[{"type":"SliderBannerHome","image":"https://assets.primaverasound.com/2018/foto_header_1440px.jpg","slugName":"homeSlider","left":[{"type":"TitleLineH1","color":"white","name":"description","margin":"mb-4","text":{"es":"PARIDAD, ECLECTICISMO Y ATREVIMIENTO EN EL REVOLUCIONARIO CARTEL DE PRIMAVERA SOUND 2019","en":"EQUALITY, ECLECTICISM AND AUDACITY IN THE REVOLUTIONARY LINE UP OF PRIMAVERA SOUND 2019","ca":"PARITAT, ECLECTICISME I ATREVIMENT EN EL REVOLUCIONARI CARTELL DE PRIMAVERA SOUND 2019"}},{"type":"LinkButtonRounded","name":"tickets","text":{"es":"Comprar Entradas","en":"Buy Tickets","ca":"Comprar entrades"},"url":"/tickets"}],"right":[{"type":"ParagraphLine","text":{"es":"¿Es el cartel de Primavera Sound 2019 normal?","en":"Is the Primavera Sound 2019 line up normal?","ca":"És el cartell de Primavera Sound 2019 normal?"}},{"type":"ButtonTag","category":"barcelona","text":{"en":"BARCELONA","es":"BARCELONA","ca":"barcelona"}}]},{"type":"SliderBannerHome","image":"https://assets.primaverasound.com/2018/foto_header_1440px.jpg","slugName":"homeSlider","left":[{"type":"TitleLineH1","color":"white","name":"description","margin":"mb-4","text":{"es":"PARIDAD, ECLECTICISMO Y ATREVIMIENTO EN EL REVOLUCIONARIO CARTEL DE PRIMAVERA SOUND 2019","en":"EQUALITY, ECLECTICISM AND AUDACITY IN THE REVOLUTIONARY LINE UP OF PRIMAVERA SOUND 2019","ca":"PARITAT, ECLECTICISME I ATREVIMENT EN EL REVOLUCIONARI CARTELL DE PRIMAVERA SOUND 2019"}},{"type":"ButtonTag","category":"barcelona","text":{"en":"BARCELONA","es":"BARCELONA","ca":"barcelona"}}],"right":[{"type":"ParagraphLine","text":{"es":"¿Es el cartel de Primavera Sound 2019 normal?","en":"Is the Primavera Sound 2019 line up normal?","ca":"És el cartell de Primavera Sound 2019 normal?"}},{"type":"LinkButtonRounded","name":"tickets","text":{"es":"Comprar Entradas","en":"Buy Tickets","ca":"Comprar entrades"},"url":"/tickets"}]}]},{"type":"BodyChildContainer","slugName":"homeBodyContainer","components":[{"type":"Launcher","params":[{"itemLayout":"single","image":{"src":"https://assets.primaverasound.com/pso/redactor/noticias/NPS19_Nota_Imprensa_940x964px_20190116153742.png"},"title":{"es":"SOLANGE, J BALVIN, ERYKAH BADU, INTERPOL, ROSALÍA Y STEREOLAB ENCABEZAN EL PARITARIO CARTEL DE NOS PRIMAVERA SOUND 2019","en":"SOLANGE, J BALVIN, ERYKAH BADU, INTERPOL, ROSALÍA AND STEREOLAB ON THE NOS PRIMAVERA SOUND 2019 LINE-UP","ca":"SOLANGE, J BALVIN, ERYKAH BADU, INTERPOL, ROSALÍA Y STEREOLAB ENCABEZAN EL PARITARIO CARTEL DE NOS PRIMAVERA SOUND 2019"},"date":"10 / 12 / 2017","order":"1","category":"oporto","tags":["nos"],"url":"/news/primavera-pack-2019-dont-stop-believing"},{"itemLayout":"single","image":{"src":"https://assets.primaverasound.com/2018/psb/images/artistas/Hinds04Seat_EricPamies.jpg"},"title":{"es":"ROOSEVELT FINALMENTE ACTUARÁ EN BARCELONA EL 28 DE MARZO","en":"ROOSEVELT WILL FINALLY PLAY IN BARCELONA ON 28TH OF MARCH","ca":"ROOSEVELT FINALMENT ACTUARÀ A BARCELONA EL 28 DE MARÇ"},"date":"10 / 12 / 2017","order":"1","category":"concerts","tags":["concerts"],"url":"/news/billie-eilishs-concert-in-barcelona-will-move-to-sant-jordi-club-due-to-the-huge-demand-for-tickets"},{"itemLayout":"double","image":{"src":"https://assets.primaverasound.com/2018/psb/images/artistas/Hinds03Seat_EricPamies.jpg"},"title":{"es":"PARIDAD, ECLECTICISMO Y ATREVIMIENTO EN EL REVOLUCIONARIO CARTEL DE PRIMAVERA SOUND 2019","en":"EQUALITY, ECLECTICISM AND AUDACITY IN THE REVOLUTIONARY LINE UP OF PRIMAVERA SOUND 2019","ca":"PARITAT, ECLECTICISME I ATREVIMENT EN EL REVOLUCIONARI CARTELL DE PRIMAVERA SOUND 2019"},"date":"05/12/2018","order":"1","category":"barcelona","tags":["BARCELONA"],"url":"news/is-this-thing-on-radio-primavera-sound-is-now-broadcasting-from-its-barcelona-studio"},{"itemLayout":"single","image":{"src":"https://assets.primaverasound.com/2018/psb/images/artistas/Hinds04Seat_EricPamies.jpg"},"title":{"es":"PRIMAVERA PACK 2019: DON’T STOP BELIEVING","en":"PRIMAVERA PACK 2019: DON’T STOP BELIEVING","ca":"PRIMAVERA PACK 2019: DON’T STOP BELIEVING"},"date":"10 / 12 / 2017","order":"1","category":"barcelona","tags":["barcelona"],"url":"/news/is-this-thing-on-radio-primavera-sound-is-now-broadcasting-from-its-barcelona-studio"},{"itemLayout":"single","image":{"src":"https://assets.primaverasound.com/2018/psb/images/artistas/Hinds04Seat_EricPamies.jpg"},"title":{"es":"VENTA DE ABONOS PARA PRIMAVERA SOUND 2019 BARCELONA","en":"EARLY BIRD TICKETS FOR PRIMAVERA SOUND 2019 BARCELONA","ca":"INICI DE LA VENDA D’ABONAMENTS PER A PRIMAVERA SOUND 2019 BARCELONA"},"date":"10 / 12 / 2017","order":"1","category":"barcelona","tags":["barcelona"],"url":"/news/roosevelt-cancels-his-show-in-barcelona-tonight"},{"itemLayout":"single","image":{"src":"https://assets.primaverasound.com/2018/psb/images/rps-red-2.png"},"title":{"es":"IS THIS THING ON? RADIO PRIMAVERA SOUND EMPIEZA A EMITIR DESDE SUS ESTUDIOS EN BARCELONA","en":"IS THIS THING ON? RADIO PRIMAVERA SOUND IS NOW BROADCASTING FROM ITS BARCELONA STUDIO","ca":"IS THIS THING ON? RADIO PRIMAVERA SOUND COMENÇA A EMETRE DES DELS SEUS ESTUDIS A BARCELONA"},"date":"10 / 12 / 2017","order":"1","category":"radio","tags":["RADIO"],"url":"/news/primavera-pack-2019-dont-stop-believing"},{"itemLayout":"single","image":{"src":"https://assets.primaverasound.com/psb/redactor/noticias/Skepta_1920x1080_20180602144424.png"},"title":{"es":"SKEPTA ACTUARÁ EN PRIMAVERA SOUND ESTA NOCHE","en":"SKEPTA WILL PLAY AT PRIMAVERA SOUND TONIGHT","ca":"SKEPTA ACTUARÀ A PRIMAVERA SOUND AQUESTA NIT"},"date":"10 / 12 / 2017","order":"1","category":"barcelona","tags":["barcelona"],"url":"/news/primavera-pack-2019-dont-stop-believing"}]}]}]},{"key":"footer-main"}]',
    };

    postAddPost({ ...formData }).then((postAddPostResultData) => {
      if (postAddPostResultData) {
        if (postAddPostResultData.isAuth) {
          if (postAddPostResultData.isAdded) {
            console.log(`postAddPost - Successfully added post with slugName ${postAddPostResultData.slugName}!`);
          } else {
            console.log('postAddPost - Failed to add post! Missing fields or slugName exists');
          }
        } else {
          console.log('postAddPost - User authentication failed!');
          history.push('/login');
        }
      } else {
        console.log('postAddPostResultData = null');
      }
    }); */

    /* // Logic for postEditPost ---------------------------------------------------------------------------------------

    const { history } = this.props;

    const formData = {
      id: '5d48293c083fb95d5b1cfdd4',
      name: 'Test Page 4',
      postCategory: [
        'barcelona',
      ],
      postDescription: {
        title: {
          en: 'Primavera Sound',
          es: 'Primavera Sound',
          ca: 'Primavera Sound',
        },
        description: {
          en: 'Primavera Sound',
          es: 'Primavera Sound',
          ca: 'Primavera Sound',
        },
        image: {
          en: 'https://assets-img.primaverasound.com/fit-in/1440x768/image.jpg',
          es: null,
          ca: null,
        },
        position: 1,
        itemLayout: '0',
        tags: [
          'barcelona',
        ],
        active: true,
      },
      slugName: 'test-page-3',
      title: 'Test Page 3',
      type: 'route',
      components: '[{"key":"header-main"},{"type":"Body","slugName":"homeBody","components":[{"type":"Carousel","slugName":"homeCarousel","section":"home","components":[{"type":"SliderBannerHome","image":"https://assets.primaverasound.com/2018/foto_header_1440px.jpg","slugName":"homeSlider","left":[{"type":"TitleLineH1","color":"white","name":"description","margin":"mb-4","text":{"es":"PARIDAD, ECLECTICISMO Y ATREVIMIENTO EN EL REVOLUCIONARIO CARTEL DE PRIMAVERA SOUND 2019","en":"EQUALITY, ECLECTICISM AND AUDACITY IN THE REVOLUTIONARY LINE UP OF PRIMAVERA SOUND 2019","ca":"PARITAT, ECLECTICISME I ATREVIMENT EN EL REVOLUCIONARI CARTELL DE PRIMAVERA SOUND 2019"}},{"type":"LinkButtonRounded","name":"tickets","text":{"es":"Comprar Entradas","en":"Buy Tickets","ca":"Comprar entrades"},"url":"/tickets"}],"right":[{"type":"ParagraphLine","text":{"es":"¿Es el cartel de Primavera Sound 2019 normal?","en":"Is the Primavera Sound 2019 line up normal?","ca":"És el cartell de Primavera Sound 2019 normal?"}},{"type":"ButtonTag","category":"barcelona","text":{"en":"BARCELONA","es":"BARCELONA","ca":"barcelona"}}]},{"type":"SliderBannerHome","image":"https://assets.primaverasound.com/2018/foto_header_1440px.jpg","slugName":"homeSlider","left":[{"type":"TitleLineH1","color":"white","name":"description","margin":"mb-4","text":{"es":"PARIDAD, ECLECTICISMO Y ATREVIMIENTO EN EL REVOLUCIONARIO CARTEL DE PRIMAVERA SOUND 2019","en":"EQUALITY, ECLECTICISM AND AUDACITY IN THE REVOLUTIONARY LINE UP OF PRIMAVERA SOUND 2019","ca":"PARITAT, ECLECTICISME I ATREVIMENT EN EL REVOLUCIONARI CARTELL DE PRIMAVERA SOUND 2019"}},{"type":"ButtonTag","category":"barcelona","text":{"en":"BARCELONA","es":"BARCELONA","ca":"barcelona"}}],"right":[{"type":"ParagraphLine","text":{"es":"¿Es el cartel de Primavera Sound 2019 normal?","en":"Is the Primavera Sound 2019 line up normal?","ca":"És el cartell de Primavera Sound 2019 normal?"}},{"type":"LinkButtonRounded","name":"tickets","text":{"es":"Comprar Entradas","en":"Buy Tickets","ca":"Comprar entrades"},"url":"/tickets"}]}]},{"type":"BodyChildContainer","slugName":"homeBodyContainer","components":[{"type":"Launcher","params":[{"itemLayout":"single","image":{"src":"https://assets.primaverasound.com/pso/redactor/noticias/NPS19_Nota_Imprensa_940x964px_20190116153742.png"},"title":{"es":"SOLANGE, J BALVIN, ERYKAH BADU, INTERPOL, ROSALÍA Y STEREOLAB ENCABEZAN EL PARITARIO CARTEL DE NOS PRIMAVERA SOUND 2019","en":"SOLANGE, J BALVIN, ERYKAH BADU, INTERPOL, ROSALÍA AND STEREOLAB ON THE NOS PRIMAVERA SOUND 2019 LINE-UP","ca":"SOLANGE, J BALVIN, ERYKAH BADU, INTERPOL, ROSALÍA Y STEREOLAB ENCABEZAN EL PARITARIO CARTEL DE NOS PRIMAVERA SOUND 2019"},"date":"10 / 12 / 2017","order":"1","category":"oporto","tags":["nos"],"url":"/news/primavera-pack-2019-dont-stop-believing"},{"itemLayout":"single","image":{"src":"https://assets.primaverasound.com/2018/psb/images/artistas/Hinds04Seat_EricPamies.jpg"},"title":{"es":"ROOSEVELT FINALMENTE ACTUARÁ EN BARCELONA EL 28 DE MARZO","en":"ROOSEVELT WILL FINALLY PLAY IN BARCELONA ON 28TH OF MARCH","ca":"ROOSEVELT FINALMENT ACTUARÀ A BARCELONA EL 28 DE MARÇ"},"date":"10 / 12 / 2017","order":"1","category":"concerts","tags":["concerts"],"url":"/news/billie-eilishs-concert-in-barcelona-will-move-to-sant-jordi-club-due-to-the-huge-demand-for-tickets"},{"itemLayout":"double","image":{"src":"https://assets.primaverasound.com/2018/psb/images/artistas/Hinds03Seat_EricPamies.jpg"},"title":{"es":"PARIDAD, ECLECTICISMO Y ATREVIMIENTO EN EL REVOLUCIONARIO CARTEL DE PRIMAVERA SOUND 2019","en":"EQUALITY, ECLECTICISM AND AUDACITY IN THE REVOLUTIONARY LINE UP OF PRIMAVERA SOUND 2019","ca":"PARITAT, ECLECTICISME I ATREVIMENT EN EL REVOLUCIONARI CARTELL DE PRIMAVERA SOUND 2019"},"date":"05/12/2018","order":"1","category":"barcelona","tags":["BARCELONA"],"url":"news/is-this-thing-on-radio-primavera-sound-is-now-broadcasting-from-its-barcelona-studio"},{"itemLayout":"single","image":{"src":"https://assets.primaverasound.com/2018/psb/images/artistas/Hinds04Seat_EricPamies.jpg"},"title":{"es":"PRIMAVERA PACK 2019: DON’T STOP BELIEVING","en":"PRIMAVERA PACK 2019: DON’T STOP BELIEVING","ca":"PRIMAVERA PACK 2019: DON’T STOP BELIEVING"},"date":"10 / 12 / 2017","order":"1","category":"barcelona","tags":["barcelona"],"url":"/news/is-this-thing-on-radio-primavera-sound-is-now-broadcasting-from-its-barcelona-studio"},{"itemLayout":"single","image":{"src":"https://assets.primaverasound.com/2018/psb/images/artistas/Hinds04Seat_EricPamies.jpg"},"title":{"es":"VENTA DE ABONOS PARA PRIMAVERA SOUND 2019 BARCELONA","en":"EARLY BIRD TICKETS FOR PRIMAVERA SOUND 2019 BARCELONA","ca":"INICI DE LA VENDA D’ABONAMENTS PER A PRIMAVERA SOUND 2019 BARCELONA"},"date":"10 / 12 / 2017","order":"1","category":"barcelona","tags":["barcelona"],"url":"/news/roosevelt-cancels-his-show-in-barcelona-tonight"},{"itemLayout":"single","image":{"src":"https://assets.primaverasound.com/2018/psb/images/rps-red-2.png"},"title":{"es":"IS THIS THING ON? RADIO PRIMAVERA SOUND EMPIEZA A EMITIR DESDE SUS ESTUDIOS EN BARCELONA","en":"IS THIS THING ON? RADIO PRIMAVERA SOUND IS NOW BROADCASTING FROM ITS BARCELONA STUDIO","ca":"IS THIS THING ON? RADIO PRIMAVERA SOUND COMENÇA A EMETRE DES DELS SEUS ESTUDIS A BARCELONA"},"date":"10 / 12 / 2017","order":"1","category":"radio","tags":["RADIO"],"url":"/news/primavera-pack-2019-dont-stop-believing"},{"itemLayout":"single","image":{"src":"https://assets.primaverasound.com/psb/redactor/noticias/Skepta_1920x1080_20180602144424.png"},"title":{"es":"SKEPTA ACTUARÁ EN PRIMAVERA SOUND ESTA NOCHE","en":"SKEPTA WILL PLAY AT PRIMAVERA SOUND TONIGHT","ca":"SKEPTA ACTUARÀ A PRIMAVERA SOUND AQUESTA NIT"},"date":"10 / 12 / 2017","order":"1","category":"barcelona","tags":["barcelona"],"url":"/news/primavera-pack-2019-dont-stop-believing"}]}]}]},{"key":"footer-main"}]',
    };

    postEditPost({ ...formData }).then((postEditPostResultData) => {
      if (postEditPostResultData) {
        if (postEditPostResultData.isAuth) {
          if (postEditPostResultData.isEdited) {
            console.log(`postEditPost - Successfully edited post with slugName ${postEditPostResultData.slugName}!`);
          } else {
            console.log('postEditPost - Failed to edit post! Missing fields or slugName does not exist');
          }
        } else {
          console.log('postEditPost - User authentication failed!');
          history.push('/login');
        }
      } else {
        console.log('postEditPostResultData = null');
      }
    }); */

    /* // Logic for postDeletePost ---------------------------------------------------------------------------------------

    const { history } = this.props;

    const formData = {
      id: '5d48293c083fb95d5b1cfdd4',
      slugName: 'test-page-3',
    };

    postDeletePost({ ...formData }).then((postDeletePostResultData) => {
      if (postDeletePostResultData) {
        if (postDeletePostResultData.isAuth) {
          if (postDeletePostResultData.isDeleted) {
            console.log(`postDeletePost - Successfully deleted post with slugName ${postDeletePostResultData.slugName}!`);
          } else {
            console.log('postDeletePost - Failed to delete post! Post does not exist.');
          }
        } else {
          console.log('postDeletePost - User authentication failed!');
          history.push('/login');
        }
      } else {
        console.log('postDeletePostResultData = null');
      }
    }); */

    /* // Logic for postAddVenue ---------------------------------------------------------------------------------------

    const { history } = this.props;

    const formData = {
      venueSlugName: 'FooBar25',
      venueName: 'Foo Bar',
      venueReadableName: { en: 'foo', es: 'foo', ca: 'foo' },
      description: { en: 'foo', es: 'foo', ca: 'foo' },
      image: { en: 'foo', es: 'foo', ca: 'foo' },
      postUri: '/foobar',
      address: 'Foo Bar',
      location: 'Foo Bar',
      country: 'Foo Bar',
      phone: '555-1234',
      latitude: 11.1,
      longitude: 22.2,
      capacity: 5000,
    };

    postAddVenue({ ...formData }).then((postAddVenueResultData) => {
      if (postAddVenueResultData) {
        if (postAddVenueResultData.isAuth) {
          if (postAddVenueResultData.isAdded) {
            console.log(`postAddVenue - Successfully added venue with venueSlugName ${postAddVenueResultData.venueSlugName}!`);
          } else {
            console.log('postAddVenue - Failed to add venue! Missing fields or venueSlugName exists');
          }
        } else {
          console.log('postAddVenue - User authentication failed!');
          history.push('/login');
        }
      } else {
        console.log('postAddVenueResultData = null');
      }
    }); */

    /* // Logic for postEditVenue ---------------------------------------------------------------------------------------

    const { history } = this.props;

    const formData = {
      id: '5d3abb1a64c953081a783409',
      venueSlugName: 'FooBar23',
      venueName: 'Foo Bar',
      venueReadableName: { en: 'foo', es: 'foo', ca: 'foo' },
      description: { en: 'foo', es: 'foo', ca: 'foo' },
      image: { en: 'foo', es: 'foo', ca: 'foo' },
      postUri: '/foobar',
      address: 'Foo Bar',
      location: 'Foo Bar',
      country: 'Foo Bar',
      phone: '555-1234',
      latitude: 11.1,
      longitude: 22.2,
      capacity: 5000,
    };

    postEditVenue({ ...formData }).then((postEditVenueResultData) => {
      if (postEditVenueResultData) {
        if (postEditVenueResultData.isAuth) {
          if (postEditVenueResultData.isEdited) {
            console.log(`postEditVenue - Successfully edited venue with venueSlugName ${postEditVenueResultData.venueSlugName}!`);
          } else {
            console.log('postEditVenue - Failed to edit venue! Missing fields or venueSlugName does not exist');
          }
        } else {
          console.log('postEditVenue - User authentication failed!');
          history.push('/login');
        }
      } else {
        console.log('postEditVenueResultData = null');
      }
    }); */

    /* // Logic for postAddArtistSet ---------------------------------------------------------------------------------------

    const { history } = this.props;

    const formData = {
      artistName: 'Foo Bar',
      artistSetName: 'Foo Bar',
      artistSetReadableName: { en: 'foo', es: 'foo', ca: 'foo' },
      artistSlugName: 'foo-bar',
      artistSetSlugName: 'foo-bar-25',
      artistReadableName: { en: 'foo', es: 'foo', ca: 'foo' },
      countryCode: 'es',
      dateTimeEndReal: '2019-07-26T08:34:34.058+0000',
      dateTimeStartReal: '2019-07-26T08:34:34.058+0000',
      dateTimeStartHuman: '2019-07-26T08:34:34.058+0000',
      duration: 60,
      image: { en: 'foo', es: 'foo', ca: 'foo' },
      mediaLinks: {
        itunes: 'foo',
        video: 'foo',
        web: 'foo',
        disco: 'foo',
      },
      postUri: '/foo-bar',
      shortTitle: { en: 'foo', es: 'foo', ca: 'foo' },
      show: 1,
      showDate: 1,
      showDateTime: 0,
      showTicket: 1,
      showVenue: 1,
      smallText: { en: 'foo', es: 'foo', ca: 'foo' },
      venueSlugName: 'foo-bar',
    };

    postAddArtistSet({ ...formData }).then((postAddArtistSetResultData) => {
      if (postAddArtistSetResultData) {
        if (postAddArtistSetResultData.isAuth) {
          if (postAddArtistSetResultData.isAdded) {
            console.log(`postAddArtistSet - Successfully added artist set with artistSetSlugName ${postAddArtistSetResultData.artistSetSlugName}!`);
          } else {
            console.log('postAddArtistSet - Failed to add artist set! Missing fields or artistSetSlugName exists');
          }
        } else {
          console.log('postAddArtistSet - User authentication failed!');
          history.push('/login');
        }
      } else {
        console.log('postAddArtistSetResultData = null');
      }
    }); */

    /* // Logic for postEditArtistSet ---------------------------------------------------------------------------------------

    const { history } = this.props;

    const formData = {
      id: '5d3ae719e1b68811d4413fc5',
      artistName: 'Foo Bar',
      artistSetName: 'Foo Bar',
      artistSetReadableName: { en: 'foo', es: 'foo', ca: 'foo' },
      artistSlugName: 'foo-bar',
      artistSetSlugName: 'foo-bar-25',
      artistReadableName: { en: 'foo', es: 'foo', ca: 'foo' },
      countryCode: 'es',
      dateTimeEndReal: '2019-07-26T08:34:34.058+0000',
      dateTimeStartReal: '2019-07-26T08:34:34.058+0000',
      dateTimeStartHuman: '2019-07-26T08:34:34.058+0000',
      duration: 80,
      image: { en: 'foo', es: 'foo', ca: 'foo' },
      mediaLinks: {
        itunes: 'foo',
        video: 'foo',
        web: 'foo',
        disco: 'foo',
      },
      postUri: '/foo-bar',
      shortTitle: { en: 'foo', es: 'foo', ca: 'foo' },
      show: 1,
      showDate: 1,
      showDateTime: 0,
      showTicket: 1,
      showVenue: 1,
      smallText: { en: 'foo', es: 'foo', ca: 'foo' },
      venueSlugName: 'foo-bar',
    };

    postEditArtistSet({ ...formData }).then((postEditArtistSetResultData) => {
      if (postEditArtistSetResultData) {
        if (postEditArtistSetResultData.isAuth) {
          if (postEditArtistSetResultData.isEdited) {
            console.log(`postEditArtistSet - Successfully edited artist set with artistSetSlugName ${postEditArtistSetResultData.artistSetSlugName}!`);
          } else {
            console.log('postEditArtistSet - Failed to edit artist set! Missing fields or artistSetSlugName does not exist');
          }
        } else {
          console.log('postEditArtistSet - User authentication failed!');
          history.push('/login');
        }
      } else {
        console.log('postEditArtistSetResultData = null');
      }
    }); */

    /* // Logic for postAddTicket ---------------------------------------------------------------------------------------

    // const { history } = this.props;

    // const formData = {
    //   beginDateTime: '2019-07-26T08:34:34.058+0000',
    //   description: { en: 'foo', es: 'foo', ca: 'foo' },
    //   endDateTime: '2019-07-26T08:34:34.058+0000',
    //   image: { en: 'foo', es: 'foo', ca: 'foo' },
    //   postUri: '/foo-bar-1',
    //   price: { eu: 100, us: 90, gb: 80 },
    //   priceBoxOffice: { eu: 100, us: 90, gb: 80 },
    //   sellers: ['seller-a', 'seller-b'],
    //   show: 1,
    //   showBeforeSellers: 1,
    //   showPastEndDate: 1,
    //   showSoldOut: 0,
    //   stock: 5000,
    //   ticketName: 'Foo Bar',
    //   ticketReadableName: { en: 'foo', es: 'foo', ca: 'foo' },
    //   ticketSlugName: 'foo-bar-2',
    //   tyc: { en: 'foo', es: 'foo', ca: 'foo' },
    // };

    // postAddTicket({ ...formData }).then((postAddTicketResultData) => {
    //   if (postAddTicketResultData) {
    //     if (postAddTicketResultData.isAuth) {
    //       if (postAddTicketResultData.isAdded) {
    //         console.log(`postAddTicket - Successfully added ticket with ticketSlugName ${postAddTicketResultData.ticketSlugName}!`);
    //       } else {
    //         console.log('postAddTicket - Failed to add ticket! Missing fields or ticketSlugName exists');
    //       }
    //     } else {
    //       console.log('postAddTicket - User authentication failed!');
    //       history.push('/login');
    //     }
    //   } else {
    //     console.log('postAddTicketResultData = null');
    //   }
    // });

    /* // Logic for postEditTicket ---------------------------------------------------------------------------------------

    const { history } = this.props;

    const formData = {
      id: '5d401b1c96645c2de59a3ab0',
      beginDateTime: '2019-07-26T08:34:34.058+0000',
      description: { en: 'foo', es: 'foo', ca: 'foo' },
      endDateTime: '2019-07-26T08:34:34.058+0000',
      image: { en: 'foo', es: 'foo', ca: 'foo' },
      postUri: '/foo-bar-1',
      price: { eu: 100, us: 90, gb: 80 },
      priceBoxOffice: { eu: 100, us: 90, gb: 80 },
      sellers: ['seller-a', 'seller-b'],
      show: 1,
      showBeforeSellers: 1,
      showPastEndDate: 1,
      showSoldOut: 0,
      stock: 5000,
      ticketName: 'Foo Bar',
      ticketReadableName: { en: 'foo', es: 'foo', ca: 'foo' },
      ticketSlugName: 'foo-bar-41',
      tyc: { en: 'foo', es: 'foo', ca: 'foo' },
    };

    postEditTicket({ ...formData }).then((postEditTicketResultData) => {
      if (postEditTicketResultData) {
        if (postEditTicketResultData.isAuth) {
          if (postEditTicketResultData.isEdited) {
            console.log(`postEditTicket - Successfully edited ticket with ticketSlugName ${postEditTicketResultData.ticketSlugName}!`);
          } else {
            console.log('postEditTicket - Failed to edit ticket! Missing fields or ticketSlugName does not exist');
          }
        } else {
          console.log('postEditTicket - User authentication failed!');
          history.push('/login');
        }
      } else {
        console.log('postEditTicketResultData = null');
      }
    }); */

    /* // Logic for postAddEvent ---------------------------------------------------------------------------------------

    // const { history } = this.props;

    const formData = {
      artistSets: ['foo-bar-a', 'foo-bar-b'],
      beginDateTime: '2019-07-26T08:34:34.058+0000',
      description: { en: 'foo', es: 'foo', ca: 'foo' },
      endDateTime: '2019-07-26T08:34:34.058+0000',
      eventsArray: [],
      eventName: 'Foo Bar',
      eventReadableName: { en: 'foo', es: 'foo', ca: 'foo' },
      eventSlugName: 'foo-bar-g',
      image: { en: 'foo', es: 'foo', ca: 'foo' },
      postUri: '/foo-bar-1',
      tickets: ['foo-bar-a', 'foo-bar-b'],
      totalCapacity: 5000,
      venues: ['foo-bar-a', 'foo-bar-b'],
    };

    postAddEvent({ ...formData }).then((postAddEventResultData) => {
      if (postAddEventResultData) {
        if (postAddEventResultData.isAuth) {
          if (postAddEventResultData.isAdded) {
            console.log(`postAddEvent - Successfully added event with eventSlugName ${postAddEventResultData.eventSlugName}!`);
          } else {
            console.log('postAddEvent - Failed to add event! Missing fields or eventSlugName exists');
          }
        } else {
          console.log('postAddEvent - User authentication failed!');
          history.push('/login');
        }
      } else {
        console.log('postAddEventResultData = null');
      }
    }); */

    /* // Logic for postEditEvent ---------------------------------------------------------------------------------------

    const { history } = this.props;

    const formData = {
      id: '5d42e3e225392b23838bce81',
      artistSets: ['foo-bar-a', 'foo-bar-b'],
      beginDateTime: '2019-07-26T08:34:34.058+0000',
      description: { en: 'foo', es: 'foo', ca: 'foo' },
      endDateTime: '2019-07-26T08:34:34.058+0000',
      eventsArray: ['foo-bar-f', 'foo-bar-t'],
      eventName: 'Foo Bar',
      eventReadableName: { en: 'foo', es: 'foo', ca: 'foo' },
      eventSlugName: 'foo-bar-a',
      image: { en: 'foo', es: 'foo', ca: 'foo' },
      postUri: '/foo-bar-1',
      tickets: ['foo-bar-a', 'foo-bar-b'],
      totalCapacity: 15000,
      venues: ['foo-bar-a', 'foo-bar-b'],
    };

    postEditEvent({ ...formData }).then((postEditEventResultData) => {
      if (postEditEventResultData) {
        if (postEditEventResultData.isAuth) {
          if (postEditEventResultData.isEdited) {
            console.log(`postEditEvent - Successfully edited event with eventSlugName ${postEditEventResultData.eventSlugName}!`);
          } else {
            console.log('postEditEvent - Failed to edit event! Missing fields or eventSlugName does not exist');
          }
        } else {
          console.log('postEditEvent - User authentication failed!');
          history.push('/login');
        }
      } else {
        console.log('postEditEventResultData = null');
      }
    }); */

    /* // Logic for postDeleteTicket ---------------------------------------------------------------------------------------

    const { history } = this.props;

    const formData = {
      id: '5c82420932524ace7adc025c',
      ticketSlugName: 'ps2019-basic',
    };

    postDeleteTicket({ ...formData }).then((postDeleteTicketResultData) => {
      if (postDeleteTicketResultData) {
        if (postDeleteTicketResultData.isAuth) {
          if (postDeleteTicketResultData.isDeleted) {
            console.log(`postDeleteTicket - Successfully deleted ticket with ticketSlugName ${postDeleteTicketResultData.ticketSlugName}!`);
          } else {
            if (postDeleteTicketResultData.isUsed.eventSlugNames.length === 0) {
              console.log('postDeleteTicket - Failed to delete ticket! Ticket does not exist.');
            } else if (postDeleteTicketResultData.isUsed.eventSlugNames.length > 0) {
              console.log(`postDeleteTicket - Failed to delete ticket! Ticket is used in eventSlugNames: ${postDeleteTicketResultData.isUsed.eventSlugNames}`);
            }
          }
        } else {
          console.log('postDeleteTicket - User authentication failed!');
          history.push('/login');
        }
      } else {
        console.log('postDeleteTicketResultData = null');
      }
    }); */

    /* // Logic for postDeleteVenue ---------------------------------------------------------------------------------------

    const { history } = this.props;

    const formData = {
      id: '5c823ca432524ace7ad93c6f',
      venueSlugName: 'ps2017-main-stage',
    };

    postDeleteVenue({ ...formData }).then((postDeleteVenueResultData) => {
      if (postDeleteVenueResultData) {
        if (postDeleteVenueResultData.isAuth) {
          if (postDeleteVenueResultData.isDeleted) {
            console.log(`postDeleteVenue - Successfully deleted venue with venueSlugName ${postDeleteVenueResultData.venueSlugName}!`);
          } else {
            if (postDeleteVenueResultData.isUsed.eventSlugNames.length === 0 && postDeleteVenueResultData.isUsed.artistSetSlugNames.length === 0) {
              console.log('postDeleteVenue - Failed to delete venue! Venue does not exist.');
            } else if (postDeleteVenueResultData.isUsed.eventSlugNames.length > 0 || postDeleteVenueResultData.isUsed.artistSetSlugNames.length > 0) {
              console.log('postDeleteVenue - Failed to delete venue! Venue is used in:');
              console.log('-> eventSlugNames:');
              console.log(postDeleteVenueResultData.isUsed.eventSlugNames);
              console.log('-> artistSetSlugNames:');
              console.log(postDeleteVenueResultData.isUsed.artistSetSlugNames);
            }
          }
        } else {
          console.log('postDeleteVenue - User authentication failed!');
          history.push('/login');
        }
      } else {
        console.log('postDeleteVenueResultData = null');
      }
    }); */

    /* // Logic for postDeleteArtistSet ---------------------------------------------------------------------------------------

    const { history } = this.props;

    const formData = {
      id: '5c8239f632524ace7ad7e5b6',
      artistSetSlugName: 'bjork-ps2018-main-stage',
    };

    postDeleteArtistSet({ ...formData }).then((postDeleteArtistSetResultData) => {
      if (postDeleteArtistSetResultData) {
        if (postDeleteArtistSetResultData.isAuth) {
          if (postDeleteArtistSetResultData.isDeleted) {
            console.log(`postDeleteArtistSet - Successfully deleted artist set with artistSetSlugName ${postDeleteArtistSetResultData.artistSetSlugName}!`);
          } else {
            if (postDeleteArtistSetResultData.isUsed.eventSlugNames.length === 0) {
              console.log('postDeleteArtistSet - Failed to delete artist set! Artist set does not exist.');
            } else if (postDeleteArtistSetResultData.isUsed.eventSlugNames.length > 0) {
              console.log(`postDeleteArtistSet - Failed to delete artist set! Artist set is used in eventSlugNames: ${postDeleteArtistSetResultData.isUsed.eventSlugNames}`);
            }
          }
        } else {
          console.log('postDeleteArtistSet - User authentication failed!');
          history.push('/login');
        }
      } else {
        console.log('postDeleteArtistSetResultData = null');
      }
    }); */

    /* // Logic for postDeleteEvent ---------------------------------------------------------------------------------------

    const { history } = this.props;

    const formData = {
      id: '5d42e3ac25392b23838bce80',
      eventSlugName: 'foo-bar-main',
    };

    postDeleteEvent({ ...formData }).then((postDeleteEventResultData) => {
      if (postDeleteEventResultData) {
        if (postDeleteEventResultData.isAuth) {
          if (postDeleteEventResultData.isDeleted) {
            console.log(`postDeleteEvent - Successfully deleted event with eventSlugName ${postDeleteEventResultData.eventSlugName}!`);
          } else {
            if (postDeleteEventResultData.isUsed.eventSlugNames.length === 0) {
              console.log('postDeleteEvent - Failed to delete event! Event does not exist.');
            } else if (postDeleteEventResultData.isUsed.eventSlugNames.length > 0) {
              console.log(`postDeleteEvent - Failed to delete event! Event is used in eventSlugNames: ${postDeleteEventResultData.isUsed.eventSlugNames}`);
            }
          }
        } else {
          console.log('postDeleteEvent - User authentication failed!');
          history.push('/login');
        }
      } else {
        console.log('postDeleteEventResultData = null');
      }
    }); */

    // ------------------------------------------------------------------------------------------------------------------

    this.setState({
      isCreateModalOn: !this.state.isCreateModalOn,
    });
  };

  toggleDisplayModal = (item) => {
    const { filteredItems } = this.state;
    const currItemData = filteredItems.filter(el => el.venueSlugName === item);
    this.setState({
      isDisplayModalOn: !this.state.isDisplayModalOn,
      currItemData,
    });
  };

  toggleModifyModal = (item) => {
    const { filteredItems } = this.state;
    const currItemData = filteredItems.filter(el => el.venueSlugName === item);
    this.setState({
      isModifyModalOn: !this.state.isModifyModalOn,
      currItemData,
    });
  };

  toggleDeleteModal = (item) => {
    const { filteredItems } = this.state;
    const currItemData = filteredItems.filter(el => el.venueSlugName === item);
    this.setState({
      isDeleteModalOn: !this.state.isDeleteModalOn,
      currItemData,
    });
  };

  toggleDeleteInfoScreen = () => this.setState({ toggleDeleteInfoScreen: !this.state.toggleDeleteInfoScreen });

  formOutput = (formOutput, action) => {
    this.setState({ formOutput });
    console.log('formOutput', formOutput);

    const { history } = this.props;
    const { filterText } = this.state;

    // const formData = {
    // venueSlugName: 'FooBar25',
    // venueName: 'Foo Bar',
    // venueReadableName: { en: 'foo', es: 'foo', ca: 'foo' },
    // description: { en: 'foo', es: 'foo', ca: 'foo' },
    // image: { en: 'foo', es: 'foo', ca: 'foo' },
    // postUri: '/foobar',
    // address: 'Foo Bar',
    // location: 'Foo Bar',
    // country: 'Foo Bar',
    // phone: '555-1234',
    // latitude: 11.1,
    // longitude: 22.2,
    // capacity: 5000,
    // };

    if (action === 'create') {
      postAddVenue({ ...formOutput }).then((postAddVenueResultData) => {
        if (postAddVenueResultData) {
          if (postAddVenueResultData.isAuth) {
            if (postAddVenueResultData.isAdded) {
              console.log(`postAddVenue - Successfully added venue with venueSlugName ${postAddVenueResultData.venueSlugName}!`);
              this.updateSearch(filterText || '');
            } else {
              console.log('postAddVenue - Failed to add venue! Missing fields or venueSlugName exists');
            }
          } else {
            console.log('postAddVenue - User authentication failed!');
            history.push('/login');
          }
        } else {
          console.log('postAddVenueResultData = null');
        }
      });
    } else if (action === 'modify') {
      postEditVenue({ ...formOutput }).then((postEditVenueResultData) => {
        if (postEditVenueResultData) {
          if (postEditVenueResultData.isAuth) {
            if (postEditVenueResultData.isEdited) {
              console.log(`postEditVenue - Successfully edited venue with venueSlugName ${postEditVenueResultData.venueSlugName}!`);
              this.updateSearch(filterText || '');
            } else {
              console.log('postEditVenue - Failed to edit venue! Missing fields or venueSlugName does not exist');
            }
          } else {
            console.log('postEditVenue - User authentication failed!');
            history.push('/login');
          }
        } else {
          console.log('postEditVenueResultData = null');
        }
      });
    }
  };

  handleDelete = (itemId, itemSlug) => {
    console.log(`the item ${itemSlug} will be deleted`);

    const { history } = this.props;

    const formData = {
      id: itemId,
      venueSlugName: slugify(itemSlug.toLowerCase()),
    };

    postDeleteVenue({ ...formData }).then((postDeleteVenueResultData) => {
      if (postDeleteVenueResultData) {
        if (postDeleteVenueResultData.isAuth) {
          if (postDeleteVenueResultData.isDeleted) {
            const { filterText } = this.state;
            console.log(`postDeleteVenue - Successfully deleted venue with venueSlugName ${postDeleteVenueResultData.venueSlugName}!`);
            this.toggleDeleteInfoScreen();
            this.setState({ canItemBeDeleted: true });
            this.updateSearch(filterText || '');
          } else {
            if (postDeleteVenueResultData.isUsed.eventSlugNames.length === 0 && postDeleteVenueResultData.isUsed.artistSetSlugNames.length === 0) {
              console.log('postDeleteVenue - Failed to delete venue! Venue does not exist.');
            } else if (postDeleteVenueResultData.isUsed.eventSlugNames.length > 0 || postDeleteVenueResultData.isUsed.artistSetSlugNames.length > 0) {
              console.log('postDeleteVenue - Failed to delete venue! Venue is used in:');
              console.log('-> eventSlugNames:');
              console.log(postDeleteVenueResultData.isUsed.eventSlugNames);
              console.log('-> artistSetSlugNames:');
              console.log(postDeleteVenueResultData.isUsed.artistSetSlugNames);
              this.toggleDeleteInfoScreen();
              this.setState({ canItemBeDeleted: false });
            }
          }
        } else {
          console.log('postDeleteVenue - User authentication failed!');
          history.push('/login');
        }
      } else {
        console.log('postDeleteVenueResultData = null');
      }
    });
  };

  render() {
    const {
      filterText, isCreateModalOn, isDisplayModalOn, isDeleteModalOn, isModifyModalOn, currItemData, canItemBeDeleted, toggleDeleteInfoScreen, filteredItems, isLoading, routePosts, page, total, rowsPerPage, sorting,
    } = this.state;

    return (
      <div className="w-full bg-white">
        <div className="flex justify-between mb-4">
          <span className="text-americaMonoBold text-26">Venues</span>
          <button
            type="button"
            className="font-americaMonoBold text-xs pr-6 pl-8 py-2 rounded-full bg-black text-white uppercase h-10 flex items-center"
            onClick={() => {
              this.handleClick('create');
            }}
          >
            Create Venue
            {' '}
            <span className="font-icon icon-add-button text-white font-black pl-3 text-base" />
          </button>
        </div>
        {isCreateModalOn && (
          <Modal title="Add Venue" handleClick={this.handleClick} type="create">
            <VenueForm routePosts={routePosts} handleClick={this.handleClick} retrieveOutput={this.formOutput} action="create" />
          </Modal>
        )}
        {isDisplayModalOn && (
          <Modal title="Display Venue" handleClick={this.handleClick} type="display">
            <VenueForm handleClick={this.handleClick} formInput={currItemData[0]} action="display" />
          </Modal>
        )}
        {isModifyModalOn && (
          <Modal title="Modify Venue" handleClick={this.handleClick} type="modify">
            <VenueForm routePosts={routePosts} handleClick={this.handleClick} retrieveOutput={this.formOutput} formInput={currItemData[0]} action="modify" />
          </Modal>
        )}
        {isDeleteModalOn && (
          <Modal title="Delete Venue" handleClick={this.handleClick} type="delete">
            <VenueForm handleClick={this.handleClick} formInput={currItemData[0]} handleDelete={this.handleDelete} canItemBeDeleted={canItemBeDeleted} toggleDeleteInfoScreen={toggleDeleteInfoScreen} action="delete" closeToggleDelete={this.toggleDeleteInfoScreen} />
          </Modal>
        )}
        <div className="mt-4">
          <Filter updateSearch={this.updateSearch} searchText={filterText} placeholder="Search venues by name or slug" />
          {isLoading && <LoadIcon />}
          {!isLoading && (filteredItems && filteredItems.length
            ? (
              <DataTable
                tableData={filteredItems}
                columns={venueColumns(this.handleClick)}
                total={total}
                page={page}
                setPage={this.loadPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={this.setRowsPerPage}
                sorting={sorting}
                setSorting={this.setSorting}
              />
            )
            : <div>{filterText ? 'No venues match that search' : 'No venues yet'}</div>)}
          {/* <DraggableList Component={TabItem} items={filteredItems} itemName="venueName" handleClick={this.handleClick} height={50} /> */}
        </div>
      </div>
    );
  }
}

VenuesContainer.propTypes = {
  history: PropTypes.shape().isRequired,
};

export default withRouter(VenuesContainer);
